module.exports = "<app-mainheader></app-mainheader>\n<app-sidebar></app-sidebar>\n<div class=\"content-wrapper\">\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/sotsys211/work/src/ecard_new/backend/src/app/layout/content/content.component.html
// module id = ../../../../../src/app/layout/content/content.component.html
// module chunks = main